<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        :class="{ 'cms-toolbar--alert': isMailAll }"
        dark
    >
    <v-toolbar-title>{{MailType_Text}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-switch
        v-model="isMailAll"
        label="전체 / 타겟"
        inset
        hide-details
    ></v-switch>
    <v-btn
        small
        outlined
        class="ml-4"
        @click="openMailConfig"
    >
        <v-icon left small>mdi-cog</v-icon>우편설정
    </v-btn>
    </v-toolbar>

    <!-- ===== 우편설정: AI친구(이름+썸네일) 관리 다이얼로그 ===== -->
    <v-dialog v-model="mailConfigDialog" max-width="640" persistent scrollable>
        <v-card>
            <v-toolbar dark color="#37474F" flat>
                <v-toolbar-title>우편설정 · AI친구 목록</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="mailConfigDialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text style="max-height:70vh;">
                <!-- 등록된 친구 목록 -->
                <div class="text-subtitle-2 font-weight-bold mt-3 mb-1">등록된 친구</div>
                <v-list two-line dense>
                    <v-list-item v-if="mailFriends.length === 0">
                        <v-list-item-content>
                            <v-list-item-subtitle>아직 등록된 친구가 없습니다. 아래에서 추가하세요.</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="(f, i) in mailFriends" :key="f.id">
                        <v-list-item-avatar tile size="48">
                            <img :src="thumbUrl(f.thumb)" alt="thumb"/>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ f.name }}</v-list-item-title>
                            <v-list-item-subtitle class="grey--text">#{{ i + 1 }} · {{ f.id }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider class="my-4"/>

                <!-- 친구 추가 폼 (추가만 가능) -->
                <div class="text-subtitle-2 font-weight-bold mb-2">친구 추가</div>
                <v-text-field
                    v-model="newFriendName"
                    label="친구 이름"
                    outlined
                    dense
                    hide-details="auto"
                    class="mb-3"
                ></v-text-field>
                <v-file-input
                    label="썸네일 이미지 (256x256 자동 재단)"
                    accept="image/*"
                    outlined
                    dense
                    prepend-icon="mdi-camera"
                    show-size
                    hide-details="auto"
                    @change="onFriendThumbChange"
                ></v-file-input>
                <div v-if="newFriendPreview" class="mt-3 d-flex align-center">
                    <v-avatar tile size="96" class="mr-3" style="border:1px solid #ccc;">
                        <img :src="newFriendPreview" alt="preview"/>
                    </v-avatar>
                    <span class="grey--text text-caption">미리보기 (256x256 재단 결과)</span>
                </div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="mailConfigDialog = false">닫기</v-btn>
                <v-btn
                    color="lime accent-3"
                    :loading="friendSaving"
                    :disabled="friendSaving"
                    @click="AddMailFriend"
                >친구 추가하기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


    <v-list>
        <!-- 유저 아이디  -->
        <v-list-item v-if="!isMailAll">
        <span class="d-inline-block" style="width:160px"><v-card-title class="font-weight-bold">타겟 유저</v-card-title></span>        
        <span v-if="!is_Target_Multi">
        <v-text-field
            label="유저 아이디 입력"
            v-model="targetUser"
            value=""            
        ></v-text-field> 
        </span>
        <!-- <v-file-input
            label="아이템을 받을 유저리스트를 csv로 올려주세요"
            v-model="inputFile"
            @change="(file) => onFileChange(file)"
        ></v-file-input>  -->
        </v-list-item>      
        <v-divider/>                     
        <!-- 우편 제목 : 기본값 설정 별도로 할 수 있다.  -->
        <v-list-item>
        <span style="width:160px"><v-card-title class="font-weight-bold">메일 제목</v-card-title></span>
        <v-text-field
            label="메일 발송 제목"
            v-model="mailTitle"
            value=""            
        ></v-text-field> 

        </v-list-item>       

        <!-- 메시지 : 기본값 설정 별도로 할 수 있다. -->
        <v-divider/>
        <v-list-item class="mt-4">
        <span style="width:160px"><v-card-title class="font-weight-bold">메시지</v-card-title></span>
        <v-textarea
            filled
            v-model="mailMessage"
            name="input-7-4"
            label="메시지를 입력하세요."
            value=""
        ></v-textarea>
        </v-list-item>       
        <!-- 수령 가능 기간 -->
        <v-divider/>     
        <v-list-item>
        <span style="width:140px"><v-card-title class="font-weight-bold">날짜 선택</v-card-title></span>        
        <!-- ====================== 시작 날짜를 지정합니다 ====================== -->
        <!-- <v-col cols="12" lg="6"> -->
        <span style="width:120px" class="mr-3">
        <v-menu
            v-model="date_picker_1"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_begin"
                clearable
                label="시작날짜"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="date_begin = null"
                style="max-width: 120px;"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date_begin"
            @change="date_picker_1 = false"
        ></v-date-picker>
        </v-menu>
        </span>
        <span style="width:120px" class="mr-3">
                            <v-menu
                                ref="menut1"
                                v-model="menut1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time1"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="time1"
                                    label="시작 시간"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="menut1"
                                v-model="time1"
                                full-width
                                :use-seconds="true"
                                @click:second="$refs.menut1.save(time1)"
                                ></v-time-picker>
                            </v-menu>
        </span>
    <span class="mr-3">
    ~~~~~~ 
    </span>
    <span style="width:120px" class="mr-3">
        <v-menu
            v-model="date_picker_2"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_end"
                clearable
                label="종료날짜 (디폴트는 한달 뒤)"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="date_end = null"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date_end"
            @change="date_picker_2 = false"
        ></v-date-picker>
        </v-menu>
        </span>
        <span style="width:120px">
                            <v-menu
                                ref="menut2"
                                v-model="menut2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time2"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="time2"
                                    label="종료 시간"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="menut2"
                                v-model="time2"
                                full-width
                                :use-seconds="true"
                                @click:second="$refs.menut2.save(time2)"
                                ></v-time-picker>
                            </v-menu>
        </span>
        <span>
        {{ computedDuration }}
        
        </span>
        </v-list-item>
        <!-- <v-list-item>
        <div class="py-3"></div>
        <span style="width:160px"><v-card-title style="font-weight:bold">아이템 타입</v-card-title></span>
        <span style="width:540px" >        
        <v-radio-group
        v-model="select_item_type"
        @change="onChangeItemType"
        row
        >
        <v-radio
            label="결제 아이템 상품"
            value="type_purchase"
        ></v-radio>
        <v-radio
            label="일반 아이템"
            value="type_item"
            ></v-radio>
        </v-radio-group>
        </span>
        </v-list-item> -->
        <!-- 지급 상품  -->
        <v-divider/>
        <template v-for="(item, index) in selected_itemList">
        <v-list-item :key="index" class="mt-4">
        <span style="width:160px"><v-card-title class="font-weight-bold">아이템 {{index + 1}}</v-card-title></span>
        <span style="width:120px" >        
        <v-select
        v-model="selected_itemList[index]"
            :items="current_reward_list"
            item-text="name"
            item-value="key"
            label="타입설정"
            @change="Refresh_ItemInfo"
            outlined
            hide-details
        ></v-select>
        </span>
        <span style="width:20px"/>
        <span v-if="IsDetailKey_List(selected_itemList[index])">
            <v-select
                v-model="selected_itemList_detail[index]"
                :items="GetDetailKeyModel(selected_itemList[index])"
                item-text="name"
                item-value="key"
                label="상세 타입"
                @change="Refresh_ItemInfo"
                outlined
                hide-details
            >
                <template v-slot:selection="{ item }">
                    <v-avatar v-if="item.thumb" tile size="22" class="mr-2"><img :src="thumbUrl(item.thumb)"/></v-avatar>
                    <span>{{ item.name }}</span>
                </template>
                <template v-slot:item="{ item }">
                    <v-avatar v-if="item.thumb" tile size="28" class="mr-2"><img :src="thumbUrl(item.thumb)"/></v-avatar>
                    <span>{{ item.name }}</span>
                </template>
            </v-select>
        </span>
        <span v-else-if="(!IsDetailKey_List(selected_itemList[index]) && IsContainDetailKey(selected_itemList[index]))">
            <v-text-field
            label="상세 타입(작성형)"
            v-model="selected_itemList_detail[index]"
            value=""            
        ></v-text-field> 
        </span>
        <span style="width:20px"/>
        <span style="width:120px">
        <v-text-field 
            label="지급포인트"
            v-model="selected_itemList_count[index]"
            value=""            
            type="number"
        ></v-text-field> 
        </span>
        <div style="width: 10px;"></div>
        <span style="width:120px">
        <v-text-field
            v-if="selected_itemList[index] == '1000002'"
            label="유지시간 (Sec)"
            v-model="selected_itemList_duration[index]"
            value=""
            type="number"
        ></v-text-field>
        </span>
        <template v-if="selected_itemList[index] == '1000002'">
        <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px" :color="Number(selected_itemList_duration[index]) === 604800 ? 'green darken-2' : 'grey lighten-2'" :dark="Number(selected_itemList_duration[index]) === 604800" :elevation="Number(selected_itemList_duration[index]) === 604800 ? 2 : 0" @click="Select_ItemSetTime(index ,604800)">1주</v-btn>
        </span>
         <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px" :color="Number(selected_itemList_duration[index]) === 1209600 ? 'green darken-2' : 'grey lighten-2'" :dark="Number(selected_itemList_duration[index]) === 1209600" :elevation="Number(selected_itemList_duration[index]) === 1209600 ? 2 : 0" @click="Select_ItemSetTime(index ,1209600)">2주</v-btn>
        </span>
         <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px" :color="Number(selected_itemList_duration[index]) === 2592000 ? 'green darken-2' : 'grey lighten-2'" :dark="Number(selected_itemList_duration[index]) === 2592000" :elevation="Number(selected_itemList_duration[index]) === 2592000 ? 2 : 0" @click="Select_ItemSetTime(index ,2592000)">한달</v-btn>
        </span>
        </template>

        <span style="width:20px"/>        
        <span v-if="(selected_itemList.length -1 ) != index">        
            <v-btn 
            elevation="2"
            icon
            outlined
            @click=OnRemoveItem(index)
            >
                <v-icon dark>
                mdi-close
                </v-icon>
            </v-btn>
        </span>
        <v-spacer/>
        </v-list-item>   
        </template> 
        <v-divider class="mt-4"/>
        <v-list-item class="mt-4">
            <v-spacer></v-spacer>
            <v-btn width="120px"  color="lime accent-3"  @click="OnRegist_Mail">등록하기</v-btn>
            <v-spacer></v-spacer>
        </v-list-item>       
        <!-- 지급 상품  -->
        <!-- 유효 기간  -->
        <!-- 등록 하기  -->



    </v-list>
    </v-card>
    
    <!-- ===== 발송 이력 1건 수정 다이얼로그 ===== -->
    <v-dialog v-model="mailDetailDialog" max-width="640" persistent scrollable>
        <v-card>
            <v-toolbar dark color="#37474F" flat>
                <v-toolbar-title>발송이력 수정 · #{{ editMail.mail_no }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="mailDetailDialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text style="max-height:70vh;">
                <v-row class="mt-1" dense>
                    <v-col cols="6"><v-text-field label="고유번호" :value="editMail.mail_no" readonly dense hide-details></v-text-field></v-col>
                    <v-col cols="6"><v-text-field label="타입" :value="editMail.type" readonly dense hide-details></v-text-field></v-col>
                    <v-col cols="6"><v-text-field label="타겟(USER_ID)" :value="editMail.target" readonly dense hide-details></v-text-field></v-col>
                    <v-col cols="6"><v-text-field label="등록일자" :value="editMail.create_dt" readonly dense hide-details></v-text-field></v-col>
                </v-row>

                <v-text-field class="mt-4" label="메일 제목" v-model="editMail.title" hide-details="auto"></v-text-field>
                <v-textarea class="mt-3" label="문구" v-model="editMail.message" auto-grow rows="3" hide-details="auto"></v-textarea>

                <div class="text-subtitle-2 font-weight-bold mt-4 mb-1">수령 시작일시</div>
                <div class="d-flex" style="gap:12px;">
                    <v-menu v-model="mailStartMenu" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="editMail.start_date" label="시작 날짜" readonly v-bind="attrs" v-on="on" hide-details style="max-width:160px;"></v-text-field>
                        </template>
                        <v-date-picker v-model="editMail.start_date" @change="mailStartMenu = false"></v-date-picker>
                    </v-menu>
                    <v-text-field v-model="editMail.start_time" label="시작 시간 (HH:mm:ss)" hide-details style="max-width:160px;"></v-text-field>
                </div>

                <div class="text-subtitle-2 font-weight-bold mt-4 mb-1">수령 종료일시</div>
                <div class="d-flex" style="gap:12px;">
                    <v-menu v-model="mailEndMenu" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="editMail.end_date" label="종료 날짜" readonly v-bind="attrs" v-on="on" hide-details style="max-width:160px;"></v-text-field>
                        </template>
                        <v-date-picker v-model="editMail.end_date" @change="mailEndMenu = false"></v-date-picker>
                    </v-menu>
                    <v-text-field v-model="editMail.end_time" label="종료 시간 (HH:mm:ss)" hide-details style="max-width:160px;"></v-text-field>
                </div>

                <v-textarea class="mt-4 mail-item-json" label="등록한 아이템 (JSON)" v-model="editMail.itemJson" auto-grow rows="6" hint="등록한 아이템(JSON 배열). 형식 유지 권장" persistent-hint></v-textarea>

                <div class="grey--text text-caption mt-4">이미 읽거나 수령한 유저에게는 소급 적용되지 않습니다.</div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="mailDetailDialog = false">취소</v-btn>
                <v-btn color="lime accent-3" @click="saveMailDetail">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
    >
    <v-toolbar-title>메일 발송 이력</v-toolbar-title>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="mail_history_all"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.MAIL_NO}}</td>
            <td>{{row.item.MAIL_INFO.title}}</td>
            <td>{{row.item._USER_ID}}</td>
            <td>{{row.item.CREATE_DT}}</td>
            <td>{{row.item.EXPIRE_START_DT + "~"+row.item.EXPIRE_END_DT}}</td>
            <td>{{row.item.USER_ID}}</td>
            <td><v-btn icon small color="primary" @click="openMailDetail(row.item)"><v-icon small>mdi-pencil</v-icon></v-btn></td>

            <!-- <td>
                <v-switch
                    :v-model="`${IsActiveState(row.item)}`"
                    label=""
                    inset
                ></v-switch>
            </td> -->
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>
    <div class='py-12'/>
    <div class='py-12'/>
    </div>   
    
</template>

<script>
const xlsx = require( "xlsx" );
//import xlsx = from 'xlsx';
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
const { FileUpload_Async, FileUpload_JSON } = require('../../util/fileutil');
export default {
    name: 'UserList',

    data: () => ({
        
        menut1: false,
        menut2:false,
        time:"",
        time1:"00:00:00",
        time2:"23:59:59",
        targetUser:'',
        isMailAll:false,
        loadingData:false,        
        mailTitle:'',
        mailMessage:'',
        date_begin: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_end:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        selected_user_container:[],

        itemInfoList:[
            {
                name:'보석',
                key:'1000001',
            },
            {
                name:'AI친구',
                key:'1000002',
                detail_keys:[{name:'(GM)AI친구',key:'2000000'}]
            }            
        ],
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_detail:[],
        selected_itemList_count:[],
        selected_itemList_duration:[],
        title_type_items:[],    //타이틀 설정 하도록 
        headers: [            
            { text: '고유번호', value: 'mail_no' },
            { text: '메일 제목', value: 'title' },
            { text: '관리자', value: 'admin' },
            { text: '등록일자', value: 'regist_date' },
            { text: '수령기간', value: 'get_date' },
            { text: '타겟', value: 'target' },
            { text: '상세', value: 'detail', sortable: false },
        ],
        mail_history_all:[
        ],
        select_item_type:"default_item",
        current_reward_list:[],
        inputFile:null,

        // === 우편설정(친구 config) ===
        mailConfigDialog:false,   // 우편설정 다이얼로그 표시여부
        mailFriends:[],           // [{ id, name, thumb }] - mail_config.json 에서 로드
        newFriendName:'',         // 추가폼 - 이름
        newFriendFile:null,       // 추가폼 - 원본 썸네일 파일
        newFriendPreview:'',      // 추가폼 - 256 재단 미리보기(dataURL)
        friendSaving:false,       // 저장중 로딩표시

        // === 발송 이력 수정 다이얼로그 ===
        mailDetailDialog: false,
        mailStartMenu: false,
        mailEndMenu: false,
        editMail: { mail_no:null, type:'', target:'', create_dt:'', title:'', message:'', start_date:'', start_time:'00:00:00', end_date:'', end_time:'23:59:59', itemJson:'[]', _orig:{} },
    }),

    created()
    {
        this.date_end = moment().add(1,'M').format('yyyy-MM-DD');
        this.LoadServerInfo();
        this.LoadMailConfig();
        this.LoadRecentMailInfo();
        this.Refresh_ItemInfo();
        let queryData = this.$route.query;
        if(queryData.USER_ID != undefined)
        {
            this.targetUser = queryData.USER_ID;
        }
      
    },

    methods:{
        ...mapActions([
            'CARRYGOLD_GET_MAIL_LIST_RECENT',
            'CARRYGOLD_CREATE_MAIL',
            'CARRYGOLD_EDIT_MAIL',
            'CARRYGOLD_GET_MAIL_USERINFO_LIST_NICK',
            'CARRYGOLD_CREATE_MAIL_MULTI'
        ]),

        // 발송 이력 1건의 상세보기 다이얼로그를 연다.
        openMailDetail(item){
            let info = item.MAIL_INFO;
            if(typeof info === 'string'){
                try { info = JSON.parse(info); } catch(e){ info = {}; }
            }
            if(info == null || typeof info !== 'object') info = {};

            const fmt = (v) => {
                if(!v) return '';
                if(typeof v === 'string' && !v.includes('T')) return v;
                return moment(v).format('YYYY-MM-DD HH:mm:ss');
            };
            let startParts = fmt(item.EXPIRE_START_DT).split(' ');
            let endParts = fmt(item.EXPIRE_END_DT).split(' ');

            this.editMail = {
                mail_no: item.MAIL_NO,
                type: item.TYPE || '',
                target: item.USER_ID || '',
                create_dt: item.CREATE_DT || '',
                title: info.title || '',
                message: info.message || '',
                start_date: startParts[0] || '',
                start_time: startParts[1] || '00:00:00',
                end_date: endParts[0] || '',
                end_time: endParts[1] || '23:59:59',
                itemJson: JSON.stringify(info.item ?? [], null, 2),
                _orig: info,
            };
            this.mailDetailDialog = true;
        },
        // 수정 내용을 저장한다. (발송 이력 1건 = 실제 유저 우편 1건)
        async saveMailDetail(){
            let parsedItems;
            try {
                parsedItems = JSON.parse(this.editMail.itemJson);
            } catch(e){
                alert('아이템 JSON 형식이 올바르지 않습니다: ' + e.message);
                return;
            }
            let start_date = (this.editMail.start_date || '').trim();
            let start_time = (this.editMail.start_time || '').trim();
            let end_date = (this.editMail.end_date || '').trim();
            let end_time = (this.editMail.end_time || '').trim();
            if(!start_date || !start_time || !end_date || !end_time){
                alert('수령 시작/종료 일시를 모두 입력하세요.');
                return;
            }
            let expire_start = start_date + ' ' + start_time;
            let expire_end = end_date + ' ' + end_time;
            let mail_info = Object.assign({}, this.editMail._orig, {
                title: this.editMail.title,
                message: this.editMail.message,
                item: parsedItems,
            });
            let mail_no = this.editMail.mail_no;
            if(!confirm('수정 내용을 저장할까요? 이미 읽거나 수령한 유저에게는 반영되지 않습니다.')) return;
            try {
                await this.CARRYGOLD_EDIT_MAIL({ mail_no, mail_info, expire_start, expire_end });
                this.LoadRecentMailInfo();
                this.mailDetailDialog = false;
                alert('수정 완료');
            } catch(e){
                console.error(e);
                alert('수정 실패: ' + (e && e.message ? e.message : e));
            }
        },

        onChangeItemType(val)
        {            
            this.select_item_type = val;
            this.selected_itemList = [];
            this.selected_itemList_detail = [];
            this.selected_itemList_count = [];
            this.Refresh_ItemInfo();

            this.current_reward_list = this.itemInfoList;
            console.log(this.select_item_type);
            
            console.log(JSON.stringify(this.current_reward_list));
            //alert(this.select_item_type);
        },
        
        LoadServerInfo(){   
            fetch(this.serverState_URL)
                    .then(response => response.json())
                    .then(data => {
                        console.log("JSJS :  "+JSON.stringify(data));
                        this.mailTitle = "이벤트보상";
                        this.mailMessage = "이벤트 보상이 지급 되었습니다.";
                        this.current_reward_list = this.itemInfoList;         
                        console.log("LoadServerInfo :  "+JSON.stringify(this.itemInfoList));
                        //this.purchaseInfoList =body_data.server_state.SERVICE_OPTION.purchase_opt;
                    })
                    .catch(error => {
                        console.error('Error fetching server state:', error);
                    });
        },

        // ===== 우편설정(AI친구 config) =====
        // carrygold ServerState.json 과 같은 폴더의 mail_config.json 을 사용한다.
        // (주의) this.serverState_URL computed 은 버그로 CPU 경로를 반환하므로,
        //        여기서는 config.serverState_URL_CARRY_GOLD 를 직접 사용한다.
        mailConfigUrl(){
            // 캐시 회피용 쿼리스트링(브라우저/CDN 캐시로 옛 값이 보이는 것 방지)
            return config.serverState_URL_CARRY_GOLD.replace('ServerState.json', 'mail_config.json') + '?t=' + Date.now();
        },
        mailConfigUploadKey(){
            // S3 저장 key = 표시URL 에서 버킷 base 를 제거한 경로
            let base = config.serverState_URL_CARRY_GOLD.replace('ServerState.json', 'mail_config.json');
            return base.replace(config.s3_ImgQuizBucket, '');
        },
        thumbUrl(path){
            if(!path) return '';
            if(/^https?:\/\//.test(path)) return path;   // 이미 전체 URL 이면 그대로
            return config.s3_ImgQuizBucket + path;
        },
        openMailConfig(){
            this.newFriendName = '';
            this.newFriendFile = null;
            this.newFriendPreview = '';
            this.mailConfigDialog = true;
        },
        LoadMailConfig(){
            fetch(this.mailConfigUrl())
                .then(response => {
                    if(!response.ok) throw new Error('mail_config.json 없음 (' + response.status + ')');
                    return response.json();
                })
                .then(data => {
                    this.mailFriends = (data && Array.isArray(data.friends)) ? data.friends : [];
                    console.log('LoadMailConfig : ' + JSON.stringify(this.mailFriends));
                })
                .catch(error => {
                    // 최초에는 파일이 없을 수 있음 → 빈 목록으로 시작
                    this.mailFriends = [];
                    console.log('LoadMailConfig(빈 목록으로 시작):', error.message);
                });
        },
        SaveMailConfig(){
            // 현재 mailFriends 를 mail_config.json 으로 S3 업로드
            return FileUpload_JSON({ friends: this.mailFriends }, this.mailConfigUploadKey());
        },
        // 원본 이미지를 256x256 정사각형으로 center-crop(cover) 재단
        resizeImageTo256(file){
            return new Promise((resolve, reject) => {
                const img = new Image();
                const url = URL.createObjectURL(file);
                img.onload = () => {
                    URL.revokeObjectURL(url);
                    const size = 256;
                    const canvas = document.createElement('canvas');
                    canvas.width = size;
                    canvas.height = size;
                    const ctx = canvas.getContext('2d');
                    // cover: 짧은 쪽을 채우고 넘치는 부분은 잘라냄
                    const scale = Math.max(size / img.width, size / img.height);
                    const w = img.width * scale;
                    const h = img.height * scale;
                    const dx = (size - w) / 2;
                    const dy = (size - h) / 2;
                    ctx.drawImage(img, dx, dy, w, h);
                    canvas.toBlob((blob) => {
                        if(!blob){ reject(new Error('이미지 재단(toBlob) 실패')); return; }
                        const outFile = new File([blob], 'thumb.png', { type: 'image/png' });
                        resolve({ file: outFile, dataUrl: canvas.toDataURL('image/png') });
                    }, 'image/png');
                };
                img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('이미지 로드 실패')); };
                img.src = url;
            });
        },
        onFriendThumbChange(file){
            this.newFriendFile = null;
            this.newFriendPreview = '';
            if(!file) return;
            this.resizeImageTo256(file)
                .then(({ file: resized, dataUrl }) => {
                    this.newFriendFile = resized;
                    this.newFriendPreview = dataUrl;
                })
                .catch(err => {
                    console.error(err);
                    alert('이미지 처리에 실패했습니다: ' + err.message);
                });
        },
        async AddMailFriend(){
            let name = (this.newFriendName || '').trim();
            if(name === ''){ alert('친구 이름을 입력하세요.'); return; }
            if(!this.newFriendFile){ alert('썸네일 이미지를 선택하세요.'); return; }
            this.friendSaving = true;
            try {
                // 1) 썸네일 S3 업로드 (carrygold/mail/thumbnail/friend_{ts}.png)
                let key = 'carrygold/mail/thumbnail/friend_' + Date.now() + '.png';
                let ok = await FileUpload_Async(this.newFriendFile, key);
                if(!ok){ alert('썸네일 업로드에 실패했습니다.'); return; }
                // 2) 목록에 추가 (추가만 가능)
                let friend = { id: 'F' + Date.now(), name: name, thumb: key };
                this.mailFriends.push(friend);
                // 3) mail_config.json 저장
                let saved = await this.SaveMailConfig();
                if(!saved){
                    // 저장 실패 시 롤백
                    this.mailFriends.pop();
                    alert('mail_config.json 저장에 실패했습니다.');
                    return;
                }
                // 4) 폼 초기화
                this.newFriendName = '';
                this.newFriendFile = null;
                this.newFriendPreview = '';
                alert('친구가 추가되었습니다.');
            } catch(e){
                console.error(e);
                alert('친구 추가 중 오류: ' + e.message);
            } finally {
                this.friendSaving = false;
            }
        },

        LoadRecentMailInfo(){
            //let packageName = this.$store.state.selected_game_package;
            //let server_index = this.$store.state.selected_game_server;
            this.CARRYGOLD_GET_MAIL_LIST_RECENT({}).then((body_data)=>{
                this.mail_history_all = body_data.recent_mail_list;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })

        },

        OnClickUserInfo(_item)
        {
            this.loadingData = true;
            alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            alert(_item.user_id + "에게 메일을 보내려고합니다.");
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        OnRegist_Mail()
        {
            //alert('우편을 등록하려 합니다. 내용 확인 ㅇㅈ?');
            if(!this.isMailAll)
            {
                if(this.targetUser == '' && this.selected_user_container.length == 0)
                {
                    alert('타겟 유저발송은 유저아이디를 입력해야합니다.');
                    return;
                }
            }
            this.Make_ItemResultInfo();
            let packageName = this.$store.state.selected_game_package;
            let mailData = '';
            let reward_item = this.Make_ItemResultInfo();
            // 이쪽에 시간을 그냥 임이의 시간을 넣어주는 것이 아닌 시간을 지정하여서 넣어준다.2021-11-10 23:59:00
            let expire_start =   this.date_begin + ' ' + this.time1;
            let expire_end =   this.date_end + ' ' + this.time2;
            let mail_type = this.isMailAll ?'all':'single';
            let user_id = this.targetUser;
            let mail_info = {};
            mail_info.item = reward_item;
            mail_info.title = this.mailTitle;
            mail_info.message = this.mailMessage;
            if(reward_item.length == 0)
            {
                if(!confirm("아이템이 지정되지 않았습니다. 그래도 보내시겠습니까?"))
                {
                    return;
                }
            }


            if(this.isMailAll)
            {
                user_id = 'ALL';
                if(this.select_item_type == "type_purchase")
                {
                    alert("결제상품은 전체보내기로 등록할 수 없습니다.");
                    return;
                }
            }
            else
            {
                if(this.select_item_type == "type_purchase")
                {
                    mail_type = 'CSP';
                    mail_info.title = '결제상품';
                    mail_info.message = '결제상품';
                    let create_item_result = this.Make_ItemResultInfo_Purchase();
                    //Object.keys(dictionary).length
                    let result_item_count = Object.keys(create_item_result);
                    console.log(">>>>>>>>>>>> "+result_item_count);
                    if(result_item_count == 0)
                    {
                        alert("지정된 아이템 없음");
                    }                
                    mail_info = create_item_result;
                }      
            }
                

            if(!this.isMailAll && this.selected_user_container.length > 0)
            {
                let user_list = this.selected_user_container;
                let server_index = this.$store.state.selected_game_server;

                this.CARRYGOLD_CREATE_MAIL_MULTI({user_list, mail_info,expire_start, expire_end , server_index}).then((body_data)=>{
                    console.log("CREATE_MAIL_MULTI"+JSON.stringify(body_data));
                    this.mail_history_all = body_data.recent_mail_list;
                    this.LoadRecentMailInfo();
                    alert(`${JSON.stringify(body_data.count)} 명 전송완료`);
                    this.selected_user_container= [];
                    this.inputFile = null;
                    //console.log(body_data.server_state.SERVICE_OPTION.item_opt);
                    //this.itemInfoList = body_data.server_state.SERVICE_OPTION.item_opt;
                })
                .catch((err) => {
                    this.error = err;
                    console.log(err);
                })
            }
            else{
                let server_index = this.$store.state.selected_game_server;
                this.CARRYGOLD_CREATE_MAIL({mail_type , user_id , mail_info,expire_start, expire_end,server_index}).then((body_data)=>{
                    console.log("CREATE_MAIL"+JSON.stringify(body_data));
                    this.mail_history_all = body_data.recent_mail_list;
                    this.LoadRecentMailInfo();
                    alert("완료!");
                    //console.log(body_data.server_state.SERVICE_OPTION.item_opt);
                    //this.itemInfoList = body_data.server_state.SERVICE_OPTION.item_opt;
                })
                .catch((err) => {
                    this.error = err;
                    console.log(err);
                })
            }



       



        },
        Refresh_ItemInfo()
        {//등록된 아이템 정보 + 1
            let tempContainer1 = [];
            let tempContainer2 = [];
            let tempContainer3 = [];
            
            for(let index=0; index < this.selected_itemList.length; index++)
            {
                let item1 = this.selected_itemList[index];
                if(item1!= null)
                {
                    tempContainer1.push(item1);
                    let item2 = this.selected_itemList_count[index];
                    tempContainer2.push(item2 == undefined?0:item2);
                    let item3 = this.selected_itemList_duration[index];                                
                    tempContainer3.push(item3??(24*3600)); //기본값은 24시간으로 설정한다.
                }
            }
            this.selected_itemList= [];
            this.selected_itemList_count= [];
            this.selected_itemList_duration= [];

            for(let index=0; index < tempContainer1.length; index++)
            {
                let item1 = tempContainer1[index];
                if(item1!= null)
                {
                    this.selected_itemList.push(item1);
                    this.selected_itemList_count.push(tempContainer2[index]);
                    this.selected_itemList_duration.push(tempContainer3[index]);

                }
            }
            console.log("Refresh_ItemInfo : " + this.select_item_type)   ;
            if(this.select_item_type != "type_purchase" || this.selected_itemList.length == 0)
            {                
                this.selected_itemList.length = tempContainer1.length + 1;
                this.selected_itemList_count.length = tempContainer1.length + 1;
                this.selected_itemList_duration.length = tempContainer1.length + 1;
            }
        },
        OnRemoveItem(_index)
        {
            this.selected_itemList[_index] = undefined;
            this.Refresh_ItemInfo();
        },
        IsContainDetailKey(_itemKey)
        {
            if(_itemKey == undefined)
                return; 
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _itemKey)
                {

                    const isExist = Object.keys(item).includes('detail_keys')
                        return isExist;
                }
                    
            }
            return false;
        },
        IsDetailKey_List(_itemKey)
        {
            if(_itemKey == undefined)
                return false; 
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _itemKey)
                {
                    const isExist = Object.keys(item).includes('detail_keys')
                    if(isExist)
                    {
                        if(item.detail_keys.length > 0)
                            return true;
                        else
                            return false;
                    }
                }
                    
            }
            return false;
        },
        GetDetailKeyModel(_selectedItem)
        {
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _selectedItem)
                {
                    // AI친구(1000002) 는 우편설정에서 등록한 친구(이름+썸네일)를 함께 노출한다.
                    if(item.key == '1000002' && this.mailFriends.length > 0)
                    {
                        let configFriends = this.mailFriends.map(f => ({ key: f.id, name: f.name, thumb: f.thumb }));
                        return item.detail_keys.concat(configFriends);
                    }
                    return item.detail_keys;
                }
            }
            return {};
        },
        Make_ItemResultInfo()
        {
            let resultValue=[];
         
            for(let index = 0; index < this.selected_itemList.length ; index++)
            {
                let itemInfo = {};
                if(this.selected_itemList[index] != undefined)
                {
                    itemInfo['key'] = this.selected_itemList[index];
                    itemInfo['count'] = this.selected_itemList_count[index];
                    itemInfo['duration'] = this.selected_itemList_duration[index];
                    
                    if(this.selected_itemList_detail[index] != undefined)
                    {
                        itemInfo['detail_key'] = this.selected_itemList_detail[index];
                        // 우편설정에서 등록한 AI친구를 골랐다면 이름/썸네일도 함께 저장한다.
                        let friend = this.mailFriends.find(f => f.id === this.selected_itemList_detail[index]);
                        if(friend)
                        {
                            itemInfo['name'] = friend.name;
                            // 전체 URL(https://...content-filecenter.../)이 아니라 S3 상대경로(carrygold/...png)만 저장
                            let thumbPath = (friend.thumb || '').replace(config.s3_ImgQuizBucket, '');
                            if(thumbPath.charAt(0) === '/') thumbPath = thumbPath.slice(1);
                            itemInfo['thumb'] = thumbPath;
                        }
                    }
                    // else
                    //     itemInfo['detail_key'] = '';
                    resultValue.push(itemInfo);
                }
            }
            return resultValue;
        },
        Make_ItemResultInfo_Purchase()
        {
            let resultValue={};            
            let key_value = this.selected_itemList[0];
            if(this.selected_itemList[0] != undefined)
            {
                resultValue['key'] =key_value;
                resultValue['name'] = key_value;
                resultValue['quantity'] = 1;
            }
            return resultValue;
        },
        add_multiple_userId(user_info)
        {   
            console.log(user_info);
        },
        onFileChange(file) {
            if(file != null)
            {
            var reader = new FileReader();
            let packageName = this.$store.state.selected_game_package;
            reader.onload = (e)=>
            {
                //var textData = reader.result;                             
                //console.log("ON READER LOAD : "+textData);   
                //console.log("JS : " + sheetName);
                this.selected_user_container = [];
                let nickContainer = [];
                let tempContainer  = [];
                let data = reader.result;
                let workBook = xlsx.read(data, { type: 'binary' });
                //this.add_multiple_userId("test");
                //Sheet1
                let sheetName = "Sheet1";
                let rows = xlsx.utils.sheet_to_json(workBook.Sheets[sheetName]);
                for(let index =0;  index < rows.length ; index++)
                {
                    let row = rows[index];
                    console.log(row);
                    if(row["USER_ID"] == undefined)
                    {///유저아이디가 없다 
                        if(row["NICK"] != undefined)
                        {
                            nickContainer.push(row["NICK"]);
                        }
                    }
                    else{
                        this.selected_user_container.push(row["USER_ID"]);
                    }
                }
                
                //console.log(JSON.stringify(this.selected_user_container));
                this.Check_ValidateUserNick(nickContainer, (_result)=>{
                    console.log("Check_ValidateUserNick : " + _result);
                    let errorMessage = "";
                    _result.user_list.forEach((item) => {
                        console.log(JSON.stringify(item));
                        if(item["USER_ID"] == undefined)
                        {
                            errorMessage += " "
                            errorMessage += item["NICK"];
                            errorMessage += " , "
                        }
                        else{
                            this.selected_user_container.push(item["USER_ID"]);
                        }
                    });
                    if(errorMessage == "")
                    {
                        alert("닉네임 검증완료!");
                    }
                    else
                    {
                        errorMessage += "\n 일부유저 닉네임이 확인되지 않습니다.";
                        alert(errorMessage);
                        this.selected_user_container = [];//비워준다 
                        this.inputFile = null;
                    }

                });
                //테이블내의 닉네임만 입력된 애들을 검증한다 
                //this.CREATE_MAIL({packageName , mail_type , user_id , mail_info,expire_start, expire_end}          
            }
            reader.readAsBinaryString(this.inputFile);
            }
         
        },
        Check_ValidateUserNick(nicklist , result_action)
        {
            let packageName = this.$store.state.selected_game_package;
            let server_index = this.$store.state.selected_game_server;
            console.log("JS: "+ JSON.stringify(nicklist));
            this.CARRYGOLD_GET_MAIL_USERINFO_LIST_NICK({packageName , nicklist , server_index}).then((body_data)=>{
                //this.mail_history_all = body_data.recent_mail_list;
                console.log("닉네임 리스트를 체크합니다 " + body_data);
                result_action(body_data);
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        Select_ItemSetTime(index , time){
            //this.selected_itemList_duration[index]  = time;
            this.$set(this.selected_itemList_duration, index, time);    
            //this.$set(this.selected_itemList_duration, index, time); // 하루
        }
    },
    computed: {
        serverState_URL () {
            return config.serverState_URL_CPU;
        },
        isLive(){
            return config.isLive;
        },
        is_Target_Multi()
        {
            if(this.selected_user_container.length == 0)
                return false;
            else 
                return true;
        },
        MailType_Text()
        {
            if(this.isMailAll)
                return "[전체메일 발송] - 신중하게 작성 요망.";
            else
                return "[타겟유저 발송] - 유저의 아이디가 필수입니다.";
        },
        MailType_TabColor()
        {
            if(this.isMailAll)
                return "red accent-4";
            else
                return "#37474F";
        },   
        computedDateFormattedMomentjs_begin () {
            return this.date_begin ? moment(this.date_begin).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.date_end ? moment(this.date_end).format('YYYY-MM-DD') : ''
        },
        computedDuration() {
            if (!this.date_begin || !this.time1 || !this.date_end || !this.time2) {
                return "(날짜 입력 필요)";
            }

            const startDateTime = moment(`${this.date_begin} ${this.time1}`, 'YYYY-MM-DD HH:mm:ss');
            const endDateTime = moment(`${this.date_end} ${this.time2}`, 'YYYY-MM-DD HH:mm:ss');

            if (!startDateTime.isValid() || !endDateTime.isValid()) {
                return "(잘못된 날짜)";
            }

            const duration = moment.duration(endDateTime.diff(startDateTime));
            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();

            return `(${days}일 ${hours}시간 ${minutes}분)`;
        }    
    },
    components:{
    },
    watch :{
        '$store.state.selected_game_package': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.LoadServerInfo();
            this.LoadRecentMailInfo();
            this.selected_itemList = [];
            this.selected_itemList_detail = [];
            this.selected_itemList_count = [];
            this.selected_itemList_duration = [];
            this.Refresh_ItemInfo();
        },
        '$store.state.selected_game_server': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.LoadServerInfo();
            this.LoadRecentMailInfo();
            this.selected_itemList = [];
            this.selected_itemList_detail = [];
            this.selected_itemList_count = [];
            this.selected_itemList_duration = [];
            this.Refresh_ItemInfo();
        },



        select_item_type:function()
        {
         //   alert("test");
        }
    }
};
</script>

<style scoped>
.mail-item-json >>> textarea {
  font-family: monospace;
  font-size: 13px;
}
@media (max-width: 600px) {
  .v-list-item {
    flex-wrap: wrap;
  }
  .v-list-item > span {
    width: 100% !important;
  }
  .v-list-item > div {
    width: 100% !important;
  }
  .v-list-item .v-card__title {
    padding: 8px 0;
  }
  .v-data-table {
    overflow-x: auto;
  }
  .v-toolbar__content {
    flex-wrap: wrap;
    height: auto !important;
    padding: 8px;
    gap: 4px;
  }
}
</style>
